import axios from '@customAxios';
var API_BASE_URL = '/api/profile';
var ProfileAxios = axios.create({
    baseURL: API_BASE_URL,
});
var fetchProfileData = function () {
    return ProfileAxios.get("/data".concat(document.location.search), {
        params: {},
        headers: { 'Cache-Control': 'no-cache' },
    });
};
var saveProfile = function (requestBody) {
    return ProfileAxios.post('/save', requestBody);
};
var signup = function (requestBody) {
    return ProfileAxios.post('signup', requestBody);
};
export { fetchProfileData, signup, saveProfile, };
